import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import Capabilities from './pages/Capabilities';
import Industries from './pages/Industries';
import { useMenu } from './components/context/MenuContext'; // Import the useMenu hook
import Careers from './pages/Careers';


const AppRoutes = () =>{

    const { selectedSubItem } = useMenu(); 

    return(
        <Routes>
            <Route path="/" element={<AboutUs />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/our-story" element={<AboutUs />} />
            <Route path="/jassacLife" element={<AboutUs />} />
            <Route path="/careers" element={<Careers />} />

            <Route path="/software-development" element={<Capabilities selectedSubItem={selectedSubItem} />} />,
            <Route path="/cloud-services" element={<Capabilities selectedSubItem={selectedSubItem} />} />,
            <Route path="/product-engineering" element={<Capabilities  selectedSubItem={selectedSubItem}/>} />,
            <Route path="/video-engineering" element={<Capabilities selectedSubItem={selectedSubItem} />} />,
            <Route path="/sre" element={<Capabilities selectedSubItem={selectedSubItem}/>} />,
            <Route path="/iLiveBeam" element={<Capabilities selectedSubItem={selectedSubItem} />} />,
            <Route path="/banking" element={<Industries selectedSubItem={selectedSubItem}/>} />,
            <Route path="/capital-Markets" element={<Industries selectedSubItem={selectedSubItem} />} />,
            <Route path="/communications" element={<Industries selectedSubItem={selectedSubItem}/>} />,
            <Route path="/consumer" element={<Industries selectedSubItem={selectedSubItem}/>} />,
            <Route path="/education" element={<Industries selectedSubItem={selectedSubItem}/>} />,
            <Route path="/energy" element={<Industries selectedSubItem={selectedSubItem}/>} />,
            <Route path="/healthcare" element={<Industries selectedSubItem={selectedSubItem}/>} />,
            <Route path="/insurance" element={<Industries selectedSubItem={selectedSubItem}/>} />,
            <Route path="/retail" element={<Industries  selectedSubItem={selectedSubItem}/>} />,
            <Route path="/travel-logistics" element={<Industries selectedSubItem={selectedSubItem} />} />
            <Route path="/defense" element={<Industries selectedSubItem={selectedSubItem} />} />
            <Route path="/customerStories" element={<Industries selectedSubItem={selectedSubItem}/>} />
            <Route path="/perspectives" element={<Industries selectedSubItem={selectedSubItem} />} />
        </Routes>
    )
}

export default AppRoutes;